module.exports = __webpack_public_path__ + "static/img/h5-hot.c18d01d9.jpg";